import React from 'react';
import PropTypes from 'prop-types';

import Spinner from 'components/Common/Spinner';

const Button = ({
  children,
  type,
  full,
  disabled,
  marginBottom,
  isLoading,
  ...rest
}) => {
  const classList = ['button'];

  if (full) {
    classList.push('button--full');
  }

  if (marginBottom) {
    classList.push('button--margin-bottom');
  }

  if (disabled) {
    classList.push('button--disabled');
  }

  if (isLoading) {
    classList.push('button--loading');
  }

  return (
    <button
      type={type}
      className={classList.join(' ')}
      disabled={disabled || isLoading}
      {...rest}
    >
      <span style={{ visibility: isLoading ? 'hidden' : 'visible' }}>
        {children}
      </span>
      {isLoading && <Spinner neutral />}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string,
  full: PropTypes.bool,
  marginBottom: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool
};

Button.defaultProps = {
  children: null,
  type: 'button',
  full: false,
  marginBottom: false,
  disabled: false,
  isLoading: false
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Common/Button/Button.js